import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

document.addEventListener('DOMContentLoaded',function() {
    gsap.registerPlugin(ScrollTrigger);
    
    window.anims = function() {   
        if (document.getElementsByClassName('c-hero')[0]) {
            const hero = function() {
                gsap.to('.c-hero .blobs', {
                    scrollTrigger: { trigger: '.c-hero', scrub: true, }, y: 80
                });
            }();
        }
        
        if (document.getElementsByClassName('c-about')[0]) {
            const about = function() {
                gsap.to('.c-about .circle--magenta', {
                    scrollTrigger: { trigger: '.c-about', scrub: true, }, y: 40
                });
                
                gsap.to('.c-about .circle--white', {
                    scrollTrigger: { trigger: '.c-about', scrub: true }, y: 60
                });  
            }();
        }
        
        if (document.getElementsByClassName('c-book')[0]) {
            gsap.from('.c-book .c-book__buttons', {
                scrollTrigger: { trigger: '.c-book .c-book__buttons', scrub: 1.2 }, y: -50
            });

            gsap.from('.c-book .dashes--2', {
                scrollTrigger: { trigger: '.c-book', scrub: true, }, x: 140
            });  
            
            gsap.from('.c-book .circles--1', {
                scrollTrigger: { trigger: '.c-book', scrub: true, }, scale: .2
            });              
        }
        
        if (document.getElementsByClassName('c-boxes')[0]) {
            gsap.from('.c-boxes .oval--1', {
                scrollTrigger: { trigger: '.c-boxes .oval--1', scrub: 1.2, invalidateOnRefresh: true }, y: 140
            });
            
            gsap.from('.c-boxes .dots--1', {
                scrollTrigger: { trigger: '.c-boxes .dots--1', scrub: 1.2, invalidateOnRefresh: true  }, x: 140
            });
            
            gsap.from('.c-boxes .swiper-container', {
                scrollTrigger: {
                    trigger: '.c-boxes .swiper-container',
                    scrub: 2.2,
                    start: 'top bottom',
                    end: 'top center'
                },      
                xPercent: -15
            });
        }
        
        if (document.getElementsByClassName('c-findplace')[0]) {
            gsap.from('.c-findplace .bubble--1', {
                scrollTrigger: { trigger: '.c-findplace', scrub: 1.5, start: 'top 50%' }, y: -120
            });
            
            gsap.from('.c-findplace .bubble--2', {
                scrollTrigger: { trigger: '.c-findplace__content', scrub: 1.5, start: 'top 50%' }, scale: .5
            });
            

            if (document.querySelector('.bubble--9')) {
                gsap.from('.c-findplace__results .bubble--9', {
                    scrollTrigger: { trigger: '.c-findplace__results .bubble--9', scrub: 2.5, start: 'top center' }, scale: .5
                });
            }
            
            gsap.from('.c-findplace .dashes--1', {
                scrollTrigger: { trigger: '.c-findplace .dashes--1', scrub: 1.2 }, x: -140
            });
        }
        
        if (document.getElementsByClassName('c-gallery')[0]) {
            gsap.from('.c-gallery', {
                scrollTrigger: {
                    trigger: '.c-gallery',
                    scrub: 2.2,
                    start: 'top bottom',
                    end: 'top center'
                },      
                yPercent: -15
            });
        }
        
        if (document.getElementsByClassName('c-findplace--results')[0]) {
            gsap.from('.c-findplace .bubble--3', {
                scrollTrigger: { trigger: '.c-findplace__content', scrub: 1 }, y: -200
            }); 
            
            gsap.from('.c-findplace .bubble--4', {
                scrollTrigger: { trigger: '.c-findplace__content', scrub: 1 }, y: -250
            });
            
            gsap.from('.c-findplace .bubble--5', {
                scrollTrigger: { trigger: '.c-findplace__content', scrub: 1 }, x: -150
            });
            
            gsap.from('.c-findplace .bubble--6', {
                scrollTrigger: { trigger: '.c-findplace__content', scrub: 1.5 }, y: -150
            });
            
            gsap.from('.c-findplace .bubble--7', {
                scrollTrigger: { trigger: '.c-findplace__content', scrub: 1 }, y: -150
            });
            
            gsap.from('.c-findplace .bubble--8', {
                scrollTrigger: { trigger: '.c-findplace__content', scrub: 1.5 }, y: 50
            });
        }
        
        if (document.getElementsByClassName('c-numbers')[0]) {
            const numbers = function() {
                gsap.from('.c-numbers .circles', {
                    scrollTrigger: { trigger: '.c-numbers .o-cols ', scrub: 1.2, }, y: 40
                });
                
                gsap.to('.c-numbers .dots', {
                    scrollTrigger: { trigger: '.c-numbers', scrub: 1.2, }, y: 100
                });
            }();
        }

        if (document.getElementsByClassName('c-offer')[0]) {
            gsap.from('.c-offer .o-dots--03', {
                scrollTrigger: { trigger: '.c-offer', scrub: 1.2, }, x: 100
            });
            
            gsap.from('.c-offer .o-dots--02', {
                scrollTrigger: { trigger: '.c-offer', scrub: 1.2, }, y: 200
            });
            
            gsap.from('.c-offer .o-dots--01', {
                scrollTrigger: { trigger: '.c-offer', scrub: 1.2, }, y: 300
            });
            
            gsap.from('.c-offer .o-dots--04', {
                scrollTrigger: { trigger: '.c-offer__benefits', scrub: 1.2, }, x: -30
            });
            
            gsap.from('.c-offer .o-dots--05', {
                scrollTrigger: { trigger: '.c-offer__benefits', scrub: 1.2, }, y: -500
            });
        }
        
        if (document.getElementsByClassName('c-ourvalues')[0]) {
            gsap.from('.c-ourvalues .o-dots--01', {
                scrollTrigger: { trigger: '.c-ourvalues .o-dots--01', scrub: 1.2, invalidateOnRefresh: true }, x: -140
            });
            
            gsap.from('.c-ourvalues .o-dots--02', {
                scrollTrigger: { trigger: '.c-ourvalues .o-dots--02', scrub: 1.2, invalidateOnRefresh: true }, y: 140
            });
            
            gsap.from('.c-ourvalues .o-dots--03', {
                scrollTrigger: { trigger: '.c-ourvalues .o-dots--03', scrub: 1.2, invalidateOnRefresh: true }, y: 140
            });

            gsap.from('.c-ourvalues .o-dots--04', {
                scrollTrigger: { trigger: '.c-ourvalues .o-dots--04', scrub: 1.2, invalidateOnRefresh: true }, x: 70
            });
        }
        
        if (document.getElementsByClassName('c-reviews')[0]) {
            gsap.from('.c-reviews .dashes--1', {
                scrollTrigger: { trigger: '.c-reviews .dashes--1', scrub: 1.2 }, x: 240
            });
            
            gsap.from('.c-reviews .dots--1', {
                scrollTrigger: { trigger: '.c-reviews .dots--1', scrub: 1.2 }, y: 140
            });
            
            gsap.from('.c-reviews .swiper-container', {
                scrollTrigger: {
                    trigger: '.c-reviews .swiper-container',
                    scrub: 2.2,
                    start: 'top bottom',
                    end: 'top center'
                },      
                xPercent: 15
            });
        }
        
        if (document.getElementsByClassName('c-standout')[0]) {
            const standout = function() {
                ScrollTrigger.batch(".c-standout figure img", {
                    onEnter: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: {each: 0.15, grid: [1, 3]}, overwrite: true}),
                    onLeave: batch => gsap.set(batch, {opacity: 0, y: -100, overwrite: true}),
                    onEnterBack: batch => gsap.to(batch, {opacity: 1, y: 0, stagger: 0.15, overwrite: true}),
                    onLeaveBack: batch => gsap.set(batch, {opacity: 0, y: 100, overwrite: true})
                });
                
                const bubbles = function() {
                    gsap.from('.c-standout .bubbles--right', {
                        scrollTrigger: { trigger: '.c-standout', scrub: 1.5 }, y: -130
                    });  
                }();
            }();
        }
        
        if (document.getElementsByClassName('c-offers')[0]) {
            const offers = function() {
                gsap.from('.c-offers .blob', {
                    scrollTrigger: { trigger: '.c-offers', scrub: 1.2, }, y: -50
                });
            }();
        }

        if (document.getElementsByClassName('c-hr')[0]) {
            const hr = function() {
                gsap.from('.c-hr .blobs--left', {
                    scrollTrigger: { trigger: '.c-hr', scrub: true, }, x: 80, scale: .8
                });
                
                gsap.from('.c-hr .blobs--right', {
                    scrollTrigger: { trigger: '.c-hr', scrub: true, }, x: 80, scale: .8
                });
                
                gsap.to('.c-hr .circle--magenta', {
                    scrollTrigger: { trigger: '.c-hr', scrub: true, }, y: 120
                });
                
                gsap.from('.c-hr .circle--gray', {
                    scrollTrigger: { trigger: '.c-newsfb', scrub: true, }, y: 120
                });
            }()
        }
        
        if (document.getElementsByClassName('c-process')[0]) {
            const process = function() {
                gsap.utils.toArray(".c-process .rect").forEach(function(section) {
                    gsap.from(section, {
                        scrollTrigger: {
                            trigger: section,
                            scrub: 1,
                        },
                        scaleY: 0
                    });
                });
            }();
        }
        
        if (document.querySelector('.content-search')) {
            const elem = document.querySelector('.content-search');   
       
            let observer = new MutationObserver(mutationRecords => {
                setTimeout(function() {
                    ScrollTrigger.refresh();
                })
            });
            
            observer.observe(elem, {
                childList: true, 
                subtree: true,
                characterDataOldValue: true
            });
        }
    };
    
    
/*
    window.addEventListener('load', function() {
       // console.clear();
       // console.log('refresh');
        
        setTimeout(function() {
            ScrollTrigger.refresh();            
        }, 2000)
    })
*/

}, false)
